
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AIToolsPage = lazy(() => import('../pages/ai-tools/page'));
const AppPage = lazy(() => import('../pages/app/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const DemoPage = lazy(() => import('../pages/demo/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Service pages
const AIClonePage = lazy(() => import('../pages/services/ai-clone/page'));
const AIStagingPage = lazy(() => import('../pages/services/ai-staging/page'));
const ClientManagementPage = lazy(() => import('../pages/services/client-management/page'));
const LeadGenerationPage = lazy(() => import('../pages/services/lead-generation/page'));
const ListingAutomationPage = lazy(() => import('../pages/services/listing-automation/page'));
const MarketAnalyticsPage = lazy(() => import('../pages/services/market-analytics/page'));

// AI Tools pages
const AutomationPage = lazy(() => import('../pages/ai-tools/automation/page'));
const ChatbotsPage = lazy(() => import('../pages/ai-tools/chatbots/page'));
const SocialMediaPage = lazy(() => import('../pages/ai-tools/social-media/page'));

// Resources pages
const DocsPage = lazy(() => import('../pages/resources/docs/page'));
const CaseStudiesPage = lazy(() => import('../pages/resources/case-studies/page'));
const TrainingPage = lazy(() => import('../pages/resources/training/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/services/ai-clone',
    element: <AIClonePage />
  },
  {
    path: '/services/ai-staging',
    element: <AIStagingPage />
  },
  {
    path: '/services/client-management',
    element: <ClientManagementPage />
  },
  {
    path: '/services/lead-generation',
    element: <LeadGenerationPage />
  },
  {
    path: '/services/listing-automation',
    element: <ListingAutomationPage />
  },
  {
    path: '/services/market-analytics',
    element: <MarketAnalyticsPage />
  },
  {
    path: '/ai-tools',
    element: <AIToolsPage />
  },
  {
    path: '/ai-tools/automation',
    element: <AutomationPage />
  },
  {
    path: '/ai-tools/chatbots',
    element: <ChatbotsPage />
  },
  {
    path: '/ai-tools/social-media',
    element: <SocialMediaPage />
  },
  {
    path: '/app',
    element: <AppPage />
  },
  {
    path: '/pricing',
    element: <PricingPage />
  },
  {
    path: '/resources',
    element: <ResourcesPage />
  },
  {
    path: '/resources/docs',
    element: <DocsPage />
  },
  {
    path: '/resources/case-studies',
    element: <CaseStudiesPage />
  },
  {
    path: '/resources/training',
    element: <TrainingPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/careers',
    element: <CareersPage />
  },
  {
    path: '/partners',
    element: <PartnersPage />
  },
  {
    path: '/support',
    element: <SupportPage />
  },
  {
    path: '/demo',
    element: <DemoPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
